import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request
interface SchemeInfo {
  content: any // 方案内容
  name: string // 方案名称
  type: string // 方案类型
  createMan?: string // 创建人
  id?: string // 方案id
  isDefault?: string // 是否默认
}

export const GET_SCHEME_LIST = (params: any) =>
  GET(`${HTTP}/scheme/getMySchemeList`, params, params)

// 新增方案
export const POST_ADD_SCHEME = (params: SchemeInfo) =>
  POST(`${HTTP}/scheme/addScheme`, params, 'application/json')

// 删除方案
export const POST_DELETE_SCHEME = (params: { id: string }) =>
  POST(`${HTTP}/scheme/deleteScheme`, params, 'application/json')

// 修改方案
export const POST_UPDATE_SCHEME = (params: SchemeInfo) =>
  POST(`${HTTP}/scheme/updateScheme`, params, 'application/json')

// 方案详情
export const GET_SCHEME_DETAIL = (params: { schemeId: string }) =>
  GET(`${HTTP}/scheme/getSchemeDetail`, params)

// 方案设为默认
export const POST_SET_DEFAULT = (params: { id: string }) =>
  POST(`${HTTP}/scheme/setSchemeDefault`, params, 'application/json')
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request
interface SchemeInfo {
  content: any // 方案内容
  name: string // 方案名称
  type: string // 方案类型
  createMan?: string // 创建人
  id?: string // 方案id
  isDefault?: string // 是否默认
}

export const GET_SCHEME_LIST = (params: any) =>
  GET(`${HTTP}/scheme/getMySchemeList`, params, params)

// 新增方案
export const POST_ADD_SCHEME = (params: SchemeInfo) =>
  POST(`${HTTP}/scheme/addScheme`, params, 'application/json')

// 删除方案
export const POST_DELETE_SCHEME = (params: { id: string }) =>
  POST(`${HTTP}/scheme/deleteScheme`, params, 'application/json')

// 修改方案
export const POST_UPDATE_SCHEME = (params: SchemeInfo) =>
  POST(`${HTTP}/scheme/updateScheme`, params, 'application/json')

// 方案详情
export const GET_SCHEME_DETAIL = (params: { schemeId: string }) =>
  GET(`${HTTP}/scheme/getSchemeDetail`, params)

// 方案设为默认
export const POST_SET_DEFAULT = (params: { id: string }) =>
  POST(`${HTTP}/scheme/setSchemeDefault`, params, 'application/json')
